import request from '@/utils/request'
import { getShopId } from '@/api/shop/shopApi'

/**
 * 获取金币提现列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function listGoldWithdrawal(params) {
  return new Promise((resolve, reject) => {
    params.shopId = getShopId()
    request({
      url: '/gold.listGoldWithdrawal',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 审核金币提现
 * @param {Object} data 审核数据
 * @returns {Promise} Promise对象
 */
export function auditGoldWithdrawal(data) {
  return new Promise((resolve, reject) => {
    data.shopId = getShopId()
    request({
      url: '/gold.auditGoldWithdrawal',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除金币提现
 * @param {Object} data 删除数据
 * @returns {Promise} Promise对象
 */
export function deleteGoldWithdrawal(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/gold.deleteGoldWithdrawal',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}